module.exports = __webpack_public_path__ + "img/frame-line.1382a373.png";